import activityService from 'services/ActivityService';
import componentService from 'services/ComponentService';
import interactiveService from 'services/InteractiveService';
import * as coursewareTypes from 'pluginServices/constants/coursewareTypes';
import PluginService from 'services/PluginService';

export default class PluginServices {
  constructor({ target }) {
    this._target = target;
    this.coursewareType = target.type;

    this.service = {
      getCourseware: activityService.getActivity,
      [coursewareTypes.ACTIVITY]: {
        getCourseware: activityService.getActivity,
      },
      [coursewareTypes.INTERACTIVE]: {
        getCourseware: interactiveService.getInteractive,
      },
      [coursewareTypes.COMPONENT]: {
        getCourseware: componentService.getComponent,
      },
    }[this.coursewareType];
  }

  async getPlugin() {
    if (!this._pluginPromise) {
      this._pluginPromise = (async () => {
        const courseware = await this.service.getCourseware(this._target.id);
        if (!courseware) return null;

        const { pluginId, version: pluginVersion } = courseware.plugin;
        const { manifest } = await PluginService.getPlugin(pluginId, pluginVersion);
        const rootActivityId = await activityService.getRootActivityId(this._target.id);
        const { plugin: rootPlugin } = await activityService.getActivityPlugIn(rootActivityId);
        const { id, name, description, version, entryPoints, configurationSchema, defaultHeight } = manifest;
        return {
          id,
          componentId: this._target.id,
          name,
          description,
          version,
          entryPoints,
          configurationSchema,
          defaultHeight,
          rootPlugin,
        };
      })();
    }

    return this._pluginPromise;
  }

  static build(args) {
    return new PluginServices(args);
  }
}
